module.exports = "/fonts/fa-brands-400.eot?8e49b728413079dfd9ee45d0c58d54e4";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-brands-400.eot
// module id = H/1d
// module chunks = 0 1